import React from "react";

export const ComponentLoader = () => {
  return <div className="loader"></div>;
};
